<template>

  <div id="app">
    <header class="container">
      <b-row>
        <b-col>
             <router-link to="/"><img src="./assets/logo.png" class="img-fluid"></router-link>
        </b-col>
      </b-row>
    </header>
    
      <router-view v-show="active"/>
      <rebate-unavailable v-show="!active"/>
    
    <footer>
      <div class="text-center">
        <div class=""><h3>HYDRO REBATE HQ CUSTOMER SERVICE</h3></div>
        <div class="">+1 (855) 236 7384</div>
        <div class=""><a href="https://hydrosystemsco.com/privacy-policy/">PRIVACY POLICY</a></div>
        
      </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <img src="./assets/footer-logo.png" class="img-fluid">
            </div>
            <div class="col-lg-6">
              <div class="copyright">© 2019 HYDRO SYSTEMS COMPANY. ALL RIGHTS RESERVED.</div>
            </div>
        </div>
      </div>
    </footer>
    
  </div>
</template>

<script>
import RebateUnavailable from '@/components/RebateUnavailable'
export default {
  name: 'App',
  data () {
    return{
        active: false
    } 
  },
  components: {
    RebateUnavailable
  }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/App.vue